import { AdContainer } from './ad-container';
import { ContainerDimensionRetriever } from '../container-dimension-retriever/container-dimension-retriever';

export function createAdContainer(aWindow: Window): AdContainer {
  return new AdContainer(aWindow);
}

export function createContainerDimensionRetriever(
  aWindow: Window
): { adContainer: AdContainer; retriever: ContainerDimensionRetriever } {
  const adContainer = new AdContainer(aWindow);
  const retriever = new ContainerDimensionRetriever(adContainer);
  return { adContainer, retriever };
}
